import type { IUserProfileRepository } from "@/application/ports/repositories";
import type {
	UpdateUserProfileRequest,
	ChangePasswordRequest,
	UserPreferences,
	UpdateUserPreferencesRequest,
	UserProfileResponse,
	UpdateUserProfileWithAvatarRequest,
} from "@/domain/user";
import { apiClient } from "../client";

export class UserProfileRepository implements IUserProfileRepository {
	async updateProfile(
		data: UpdateUserProfileRequest,
	): Promise<UserProfileResponse> {
		const response = await apiClient.patch<UserProfileResponse>(
			"/users/me",
			data,
		);
		return response.data;
	}
	async updateProfileWithAvatar(
		data: UpdateUserProfileWithAvatarRequest,
	): Promise<UserProfileResponse> {
		const response = await apiClient.patch<UserProfileResponse>(
			"/users/me",
			data,
		);
		return response.data;
	}
	async changePassword(data: ChangePasswordRequest): Promise<void> {
		await apiClient.post("/auth/change-password", data);
	}
	async getPreferences(): Promise<UserPreferences> {
		const response = await apiClient.get<UserProfileResponse>("/users/me");
		if (!response.data.preferences) {
			return {
				prefers_dark_mode: false,
				prefers_compact_view: false,
				language: "es",
				timezone: "Europe/Madrid",
				notifications_enabled: true,
				notify_via_email: true,
				notify_via_app: true,
			};
		}
		return response.data.preferences;
	}
	async updatePreferences(
		data: UpdateUserPreferencesRequest,
	): Promise<UserPreferences> {
		const response = await apiClient.patch<UserProfileResponse>("/users/me", {
			preferences: data,
		});
		return (
			response.data.preferences || {
				prefers_dark_mode: false,
				prefers_compact_view: false,
				language: "es",
				timezone: "Europe/Madrid",
				notifications_enabled: true,
				notify_via_email: true,
				notify_via_app: true,
			}
		);
	}
	async deleteAccount(): Promise<void> {
		await apiClient.delete("/users/me");
	}
}
